document.addEventListener('DOMContentLoaded', function () {

  const popup = document.getElementById('discountPopup');
  const openBtns = document.querySelectorAll('.discount-open-popup');
  const backBtn = document.getElementById('discountBackBtn');

  let currentStep = 1;
  let selectedCode = '';
  let selectedCategory = '';
  let generatedOtp = '';
  let otpCreatedTime = 0;
  let verifiedEmail = '';
  let currentDiscountType = '';
  let verifiedMobile = '';
  let otpSent = false;
  let hasSingleCategory = false;
  let cameFromSubcategory = false;

  /* ─── ALL DISCOUNT CARDS DATA ─────────────────────────────────── */

  let discountCards = [];

  try {
    const dataEl = document.getElementById('discountCardsData');
    if (dataEl) {
      discountCards = JSON.parse(dataEl.textContent.trim());
    }
  } catch (err) {
    console.log('Could not parse discount cards data:', err);
  }

  /* ─── BACK NAVIGATION MAP ────────────────────────────────────────
     Step 1  → back → Step 2 (main category list, shown only on back)
     Step 3  → back → Step 1 (always, regardless of how we got here)
     Step 2b → back → Step 1
     Step 3a → back → Step 3
     Step 3b → back → Step 3
     Step 4  → back → Step 3                                         */

  const backMap = {
    1:    2,    // Intro           → Main Category list (back only)
    2:    null, // Main Category   → close (nowhere to go back)
    '2b': 1,    // Subcategory     → Step 1 (Intro)
    3:    1,    // Mobile          → Step 1 (always)
    '3a': 3,    // Offer Terms     → Mobile
    '3b': 3,    // FAQs            → Mobile
    4:    3     // Email           → Mobile
    // step 5 (OTP) is locked once OTP sent — handled separately
  };

  /* ─── CATEGORY DATA ─────────────────────────────────────────── */

  const categoryData = {
    essentialworkerdiscount: [
      'Healthcare Discount',
      'Teacher Discount',
      'Military Discount',
      'First Responder Discount'
    ],
    essentialworkersdiscount: [
      'Healthcare Discount',
      'Teacher Discount',
      'Military Discount',
      'First Responder Discount'
    ],
    studentdiscount: [
      'Student Discount'
    ],
    seniordiscount: [
      'Senior Citizen Discount'
    ],
    seniorcitizendiscount: [
      'Senior Citizen Discount'
    ]
  };

  /* ─── RESET POPUP ────────────────────────────────────────────── */

  function resetPopup() {

    currentStep = 1;
    selectedCode = '';
    selectedCategory = '';
    generatedOtp = '';
    otpCreatedTime = 0;
    verifiedEmail = '';
    currentDiscountType = '';
    verifiedMobile = '';
    otpSent = false;
    hasSingleCategory = false;
    cameFromSubcategory = false;

    document.getElementById('mobileInput').value = '';
    document.getElementById('emailInput').value = '';
    document.getElementById('emailOtpInput').value = '';

    document.getElementById('mobileError').innerText = '';
    document.getElementById('emailError').innerText = '';
    document.getElementById('otpError').innerText = '';

    document.getElementById('discountCodeBox').innerText = '';

    /* Close any open FAQ accordion items */
    document.querySelectorAll('.discount-faq-item.open').forEach(function (item) {
      item.classList.remove('open');
    });

    /* Re-enable send OTP button */
    const sendOtpBtn = document.getElementById('sendEmailOtp');
    sendOtpBtn.disabled = false;
    sendOtpBtn.innerText = sendOtpBtn.getAttribute('data-original-text') || 'Send OTP';

    /* Show back button again */
    backBtn.style.display = 'flex';

    showStep(1);

  }

  /* ─── SHOW STEP ──────────────────────────────────────────────── */

  function showStep(step) {

    currentStep = step;

    document.querySelectorAll('.discount-step').forEach(function (item) {
      item.classList.remove('active');
    });

    const activeStep = document.querySelector('.discount-step[data-step="' + step + '"]');

    if (activeStep) {
      activeStep.classList.add('active');
    }

  }

  /* ─── STORE ORIGINAL BUTTON TEXT ────────────────────────────── */

  const sendOtpBtn = document.getElementById('sendEmailOtp');
  if (sendOtpBtn) {
    sendOtpBtn.setAttribute('data-original-text', sendOtpBtn.innerText);
  }

  /* ─── OPEN POPUP ─────────────────────────────────────────────── */

  openBtns.forEach(function (btn) {

    btn.addEventListener('click', function () {

      resetPopup();

      popup.classList.add('show');

      currentDiscountType = this.dataset.type.trim();
      selectedCode = this.dataset.code;

      const title = this.dataset.title;
      const text  = this.dataset.text;

      document.getElementById('stepOneSmall').innerText = currentDiscountType;
      document.getElementById('stepOneTitle').innerText = title;
      document.getElementById('stepOneText').innerText  = text;

      showStep(1);

    });

  });

  /* ─── BUILD MAIN CATEGORY LIST (STEP 2) ───────────────────────
     Only shown when the user presses Back from Step 1.           */

  function renderMainCategoryList() {

    document.getElementById('categoryHeading').innerText = '';
    document.getElementById('categoryTitle').innerText   = 'Choose your discount';

    const categoryList = document.getElementById('categoryList');
    categoryList.innerHTML = '';

    const cardsToShow = discountCards.length ? discountCards : [{
      type:  currentDiscountType,
      title: document.getElementById('stepOneTitle').innerText,
      text:  document.getElementById('stepOneText').innerText,
      code:  selectedCode
    }];

    cardsToShow.forEach(function (card) {

      const item = document.createElement('div');
      item.className = 'discount-category-item';
      item.dataset.mainType  = card.type;
      item.dataset.mainTitle = card.title;
      item.dataset.mainCode  = card.code;

      const label = document.createElement('span');
      label.innerText = card.type;

      const arrow = document.createElement('span');
      arrow.innerText = '›';

      item.appendChild(label);
      item.appendChild(arrow);
      categoryList.appendChild(item);

    });

  }

  /* ─── HELPER: go directly to the right step after "Get Started" ─
     Single-subcategory → Mobile (Step 3)
     Multi-subcategory  → Subcategory list (Step 2b)               */

  function goForwardFromStep1() {

    const normalizedType = currentDiscountType.toLowerCase().replace(/[^a-z]/g, '');
    const matchedSubcategories = categoryData[normalizedType];

    if (matchedSubcategories && matchedSubcategories.length > 1) {

      /* Multi-subcategory (e.g. Essential Worker) → Step 2b */
      cameFromSubcategory = true;
      hasSingleCategory   = false;

      document.getElementById('subcategoryHeading').innerText = currentDiscountType;
      document.getElementById('subcategoryTitle').innerText   =
        document.getElementById('stepOneTitle').innerText;

      const subcategoryList = document.getElementById('subcategoryList');
      subcategoryList.innerHTML = '';

      matchedSubcategories.forEach(function (item) {
        subcategoryList.innerHTML +=
          '<div class="discount-category-item">' +
            '<span>' + item + '</span>' +
            '<span>›</span>' +
          '</div>';
      });

      showStep('2b');

    } else {

      /* Single subcategory (Student / Senior) → straight to Mobile */
      cameFromSubcategory = false;
      hasSingleCategory   = true;
      selectedCategory    = (matchedSubcategories && matchedSubcategories[0]) || currentDiscountType;

      document.getElementById('mobileHeading').innerText = selectedCategory;
      document.getElementById('mobileTitle').innerText   = '30% OFF for ' + selectedCategory;

      showStep(3);

    }

  }

  /* ─── STEP 1 → forward (Get Started) ─────────────────────────── */

  document.getElementById('goToCategories').addEventListener('click', function () {
    goForwardFromStep1();
  });

  /* ─── MAIN CATEGORY CLICK (STEP 2) ─────────────────────────────
     This step is now only reached via Back from Step 1.
     Clicking a card here replicates the original card-button behaviour:
     update currentDiscountType / selectedCode then go forward.    */

  document.addEventListener('click', function (e) {

    const mainItem = e.target.closest('#categoryList .discount-category-item');
    if (!mainItem) return;

    currentDiscountType = mainItem.dataset.mainType;
    selectedCode        = mainItem.dataset.mainCode;

    /* Update Step 1 display values so Step 1 looks correct if user
       later presses back from wherever they land                   */
    document.getElementById('stepOneSmall').innerText = currentDiscountType;
    document.getElementById('stepOneTitle').innerText = mainItem.dataset.mainTitle;

    goForwardFromStep1();

  });

  /* ─── SUBCATEGORY CLICK (STEP 2B) → STEP 3 (MOBILE) ───────────── */

  document.addEventListener('click', function (e) {

    const subItem = e.target.closest('#subcategoryList .discount-category-item');
    if (!subItem) return;

    selectedCategory = subItem.querySelector('span').innerText.trim();

    document.getElementById('mobileHeading').innerText = selectedCategory;
    document.getElementById('mobileTitle').innerText   = '30% OFF for ' + selectedCategory;

    showStep(3);

  });

  /* ─── OFFER TERMS / FAQS (from Mobile step) ─────────────────── */

  document.getElementById('openOfferTerms').addEventListener('click', function () {
    showStep('3a');
  });

  document.getElementById('openFaqs').addEventListener('click', function () {
    showStep('3b');
  });

  /* ─── FAQ ACCORDION (one open at a time) ────────────────────── */

  document.addEventListener('click', function (e) {

    const faqQuestion = e.target.closest('.discount-faq-q');
    if (!faqQuestion) return;

    const faqItem = faqQuestion.closest('.discount-faq-item');
    const wasOpen = faqItem.classList.contains('open');

    document.querySelectorAll('.discount-faq-item.open').forEach(function (item) {
      item.classList.remove('open');
    });

    if (!wasOpen) {
      faqItem.classList.add('open');
    }

  });

  /* ─── MOBILE VALIDATION ──────────────────────────────────────── */

  function validateMobile(number, country) {

    let clean = number.replace(/[^\d]/g, '');

    if (clean.startsWith('0')) {
      clean = clean.substring(1);
    }

    if (country === '+91') {
      return /^[6-9]\d{9}$/.test(clean);
    }

    if (country === '+61') {
      return /^4\d{8}$/.test(clean);
    }

    return false;

  }

  /* ─── MOBILE CONTINUE (STEP 3 → STEP 4 EMAIL) ───────────────── */

  document.getElementById('mobileContinue').addEventListener('click', function () {

    const mobile  = document.getElementById('mobileInput').value.trim();
    const country = document.getElementById('countryCode').value;
    const error   = document.getElementById('mobileError');

    error.innerText = '';

    if (!validateMobile(mobile, country)) {

      if (country === '+91') {
        error.innerText = 'Please enter valid Indian mobile number';
      } else if (country === '+61') {
        error.innerText = 'Please enter valid Australian mobile number';
      }

      return;

    }

    let cleanMobile = mobile.replace(/[^\d]/g, '');
    if (cleanMobile.startsWith('0')) {
      cleanMobile = cleanMobile.substring(1);
    }

    verifiedMobile = country + cleanMobile;

    document.getElementById('emailTitle').innerText =
      'Verify your ' + selectedCategory + ' email';

    showStep(4);

  });

  /* ─── BACK BUTTON ────────────────────────────────────────────── */

  backBtn.addEventListener('click', function () {

    /* If OTP already sent, do not allow going back */
    if (otpSent) return;

    /* Step 2 has nowhere to go back — close the popup */
    if (currentStep === 2) {
      popup.classList.remove('show');
      resetPopup();
      return;
    }

    /* Going back to Step 1: rebuild the main category list first
       so it is ready if the user then presses back again from Step 1 */
    if (currentStep === 1) {
      renderMainCategoryList();
      showStep(2);
      return;
    }

    const target = backMap[currentStep];

    if (target) {
      showStep(target);
    }

  });

  /* ─── CLOSE ON BACKDROP CLICK ────────────────────────────────── */

  popup.addEventListener('click', function (e) {

    if (e.target === popup) {
      popup.classList.remove('show');
      resetPopup();
    }

  });

  /* ─── SEND EMAIL OTP (STEP 4 → STEP 5) ──────────────────────── */

  document.getElementById('sendEmailOtp').addEventListener('click', function () {

    if (otpSent) return;

    const btn   = this;
    const email = document.getElementById('emailInput').value.trim().toLowerCase();
    const error = document.getElementById('emailError');

    error.innerText = '';

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!regex.test(email)) {
      error.innerText = 'Please enter valid email address';
      return;
    }

    const domain  = email.split('@')[1].toLowerCase();
    let allowed   = false;

    if (selectedCategory === 'Student Discount') {

      const studentDomains = ['.edu.in', '.ac.in', 'gmail.com', '.edu.au', '.ac.uk', '.edu','.com.au'];
      allowed = studentDomains.some(item => domain.endsWith(item));

    } else if (selectedCategory === 'Healthcare Discount') {

      const healthcareDomains = [
        '.health.nsw.gov.au', '.gov.au', '.org.au', '.gov.in',
        '.org.in', '.nic.in', '.hospital', '.health', '.medical', '.org'
      ];
      const healthcareKeywords = [
        'health', 'clinic', 'hospital', 'medical',
        'care', 'doctor', 'nurse', 'dental', 'pharmacy', 'physio'
      ];

      allowed =
        healthcareDomains.some(item => domain.endsWith(item)) ||
        healthcareKeywords.some(keyword => domain.includes(keyword));

    } else if (selectedCategory === 'Military Discount') {

      const militaryDomains = ['.defence.gov.au', '.gov.in', '.nic.in'];
      allowed = militaryDomains.some(item => domain.endsWith(item));

    } else if (selectedCategory === 'First Responder Discount') {

      const socialDomains = ['.gov.au', '.police.nsw.gov.au', '.fire.nsw.gov.au', '.ses.nsw.gov.au', '.ambulance.vic.gov.au', '.defence.gov.au'];
      allowed = socialDomains.some(item => domain.endsWith(item));

    } else if (selectedCategory === 'Teacher Discount') {

      const teacherDomains = [
        '.edu.in', '.ac.in', '.edu.au', '.schools.nsw.edu.au', '.school', '.edu'
      ];
      allowed = teacherDomains.some(item => domain.endsWith(item));

    } else {

      /* Senior Citizen or any other category — allow all emails */
      allowed = true;

    }

    if (!allowed) {

      if (selectedCategory === 'Student Discount') {
    error.innerText = 'Please use your student email address (.edu.au or .edu.in).';
} else if (selectedCategory === 'Healthcare Discount') {
    error.innerText = 'Please use your healthcare organisation email address (.gov.au, .org.au, etc.).';
} else if (selectedCategory === 'Military Discount') {
    error.innerText = 'Please use your military or defence email address (.gov.au or defence.gov.au).';
} else if (selectedCategory === 'Social Worker Discount') {
    error.innerText = 'Please use your social service organisation email address (.org.au, .gov.au, etc.).';
} else if (selectedCategory === 'Teacher Discount') {
    error.innerText = 'Please use your school or education email address (.edu.au or .edu.in).';
} else if (selectedCategory === 'First Responder Discount') {
    error.innerText = 'Please use your first responder email address (.gov.au).';
}

      return;

    }

    otpSent     = true;
    btn.disabled = true;
    btn.innerText = 'Sending...';

    backBtn.style.display = 'none';

    verifiedEmail   = email;
    generatedOtp    = Math.floor(100000 + Math.random() * 900000).toString();
    otpCreatedTime  = Date.now();

    const _email    = verifiedEmail;
    const _otp      = generatedOtp;
    const _category = selectedCategory;
    const _code     = selectedCode;

    if (typeof window._learnq !== 'undefined') {

      window._learnq.push([
        'identify',
        {
          $email: _email,
          $phone_number: verifiedMobile,
          $consent: ['email'],
          discount_category: _category
        }
      ]);

      setTimeout(function () {
        window._learnq.push([
          'track',
          'Discount OTP Requested',
          {
            email: _email,
            otp_code: _otp,
            category: _category,
            discount_code: _code
          }
        ]);
      }, 3000);

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ g: 'YaVpVK', email: _email })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) { console.log('Klaviyo Subscribe:', data); })
      .catch(function (err) { console.log('Klaviyo Subscribe Error:', err); });

    } else {
      console.log('Klaviyo not loaded');
    }

    showStep(5);

    var otpMsg = document.getElementById('otpSentMsg');
    if (otpMsg) { otpMsg.innerText = 'OTP sent to ' + _email; }

  });

  /* ─── VERIFY EMAIL OTP (STEP 5 → STEP 6 / STEP 7) ───────────── */

  document.getElementById('verifyEmailOtp').addEventListener('click', function () {

    const enteredOtp = document.getElementById('emailOtpInput').value.trim();
    const error      = document.getElementById('otpError');

    error.innerText = '';

    if (!enteredOtp) {
      error.innerText = 'Please enter OTP';
      return;
    }

    if (Date.now() - otpCreatedTime > 300000) {
      error.innerText = 'OTP expired. Please request again';
      return;
    }

    if (enteredOtp !== generatedOtp) {

      if (typeof window._learnq !== 'undefined') {
        window._learnq.push([
          'track',
          'Discount Verification Failed',
          {
            email: verifiedEmail,
            category: selectedCategory,
            discount_code: selectedCode
          }
        ]);
      }

      showStep(7);
      return;

    }

    if (typeof window._learnq !== 'undefined') {

      window._learnq.push([
        'identify',
        { $email: verifiedEmail, $phone_number: verifiedMobile }
      ]);

      window._learnq.push([
        'track',
        'Discount Verified',
        {
          $email: verifiedEmail,
          category: selectedCategory,
          discount_code: selectedCode
        }
      ]);

    }

    document.getElementById('discountCodeBox').innerText = selectedCode;

    document.getElementById('shopNowBtn').href =
      '/discount/' + selectedCode + '?redirect=/collections/all';

    showStep(6);

  });

  /* ─── NOT ELIGIBLE SHOP BTN ──────────────────────────────────── */

  const shopNowNotEligible = document.getElementById('shopNowBtnNotEligible');
  if (shopNowNotEligible) {
    shopNowNotEligible.href = '/collections/all';
  }

});